import IFormModel from "@/models/IFormModel";
import {ValidationRule} from "@/declarations/ValidationRule";
import OrderRules from "@/models/order/OrderRules";

export default class OrderCreate implements IFormModel {

	public companyId: string | null = null;
	public name: string | null = null;

	public reset(): void {
		this.companyId = null;
		this.name = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'companyId':
				return OrderRules.companyIdRules;
			case 'name':
				return OrderRules.nameRules;
			default:
				return [];
		}
	}

}
